import { render } from "./addProduct.vue?vue&type=template&id=3b6f1b34&scoped=true&ts=true"
import script from "./addProduct.vue?vue&type=script&lang=ts"
export * from "./addProduct.vue?vue&type=script&lang=ts"

import "./addProduct.vue?vue&type=style&index=0&id=3b6f1b34&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6f1b34"]])

export default __exports__